import { Alert, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function WeatherReportEmptyState() {
    const { t } = useTranslation("project");
    return (
        <Alert severity="info">
            <Typography variant="body2" color="textSecondary">
                {t(`projectReviewVisitV2.weatherReportsRoute.noReportFound`)}
            </Typography>
        </Alert>
    );
}
